/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q4Inputs */

const en_consult_q4 = /** @type {(inputs: Consult_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you need built?`)
};

const id_consult_q4 = /** @type {(inputs: Consult_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang perlu dibangun?`)
};

/**
* | output |
* | --- |
* | "What do you need built?" |
*
* @param {Consult_Q4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q4 = /** @type {((inputs?: Consult_Q4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q4(inputs)
	return en_consult_q4(inputs)
});